"use client";

import * as FocusScopePrimitive from "@radix-ui/react-focus-scope";
import * as React from "react";

export type FocusScopeProps = FocusScopePrimitive.FocusScopeProps;

/**
 * Traps focus within descendants (Radix primitive), matching other `@repo/ui` wrappers.
 */
export function FocusScope({ children, ...props }: FocusScopeProps) {
	return (
		<FocusScopePrimitive.Root {...props}>
			{children}
		</FocusScopePrimitive.Root>
	);
}
